import vmClient from 'app/services/vmClient';
import { Entity, IEntity, IEntityType } from 'app/types/entity';

interface IDeployInfo extends IEntity {
  attributes: {
    branch: string | null;
    revision: string | null;
    date: string | null;
  };
}

export type DeployInfo = Entity<IDeployInfo>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DeployInfo: IEntityType<IDeployInfo> = vmClient.defineClass({
  typeName: 'DeployInfo',
  version: 1,
  attributes: {
    branch: 'string',
    revision: 'string',

    // date is treated as a plain string, since it uses a different date format from other parts
    // of the API (which use ISO8601).
    date: 'string',
  },
});
